import globals from "./globals";
import $ from "cash-dom";

const component = (function () {
    /**
     * Initialize Hero instances
     */
    $(document).ready(function () {
        if ($("[data-action='info']").length) {
            if (globals.debug) console.log("component-credit initialized");

            function infoboxOpenHandler(_e) {
                var caption = $(_e.target).parents("figure").find(".credit");
                caption.addClass("on");
            }

            function infoboxCloseHandler(_e) {
                var caption = $(_e.target).parents("figure").find(".credit");
                caption.removeClass("on");
            }

            function infoboxToggleHandler(_e) {
                var caption = $(_e.target).parents("figure").find(".credit");
                caption.toggleClass("on");
            }

            $("[data-action='info']").on("mouseenter", infoboxOpenHandler).on("mouseleave", infoboxCloseHandler);

            $("body").on("keyup", "[data-action='info'].tab-focus", function (_e) {
                if (_e.which == 13) {
                    infoboxToggleHandler(_e);
                }
            });
        }
    });
})();

export default component;
